import { render, staticRenderFns } from "./CancellationRefundPolicy.vue?vue&type=template&id=31614d01&"
import script from "./CancellationRefundPolicy.vue?vue&type=script&lang=js&"
export * from "./CancellationRefundPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports